import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

// import EditImage from 'common/components/edit-image';
import EditImage from 'client/shared/components/edit-image/edit-image';

@inject('artistStore', 'userStore')
@observer
class FanInfoHeader extends React.Component {
	render () {
		const { artistStore, userStore } = this.props;
		const { userID, name, _id } = artistStore.data.artist.toPOJO();
		const { totalScore, tier } = artistStore;
		console.log("AAA");
		console.log(userID);
		console.log(_id);
		console.log(userStore.getItemByID({ _id: userID }));
		const { createdAt } = userStore.getItemByID({ _id: userID });
		const joinedDate = moment(createdAt).format('MM/DD/YY');

		return (
			<div className="grid-x grid-padding-x grid-padding-y align-middle">
				<div className="cell shrink">
					<EditImage
						store={ userStore }
						imgSrc={ userStore.data.user.get('profileImage') }
						handleImageCrop={ this.handleImageCrop } />
				</div>

				<div className="cell auto">
					<div className="grid-x grid-padding-x">
						<div className="cell small-12">
							<h2 data-ta="artistInfoHeader">{ name }</h2>
						</div>
						<div className="cell small-12">
							<div>
								<a href={ `#/submissions/artist/${_id}` }>
									Artist Score: { totalScore } | { tier }
								</a>
							</div>
						</div>
						<div className="cell small-12">
							<div>Joined On: { joinedDate } | Lifetime Subscriptions 0 | YTD Subscriptions 0 | MTD Subscriptions 0</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	@autobind
	handleImageCrop (cropResult) {
		this.props.userStore.setProfileImageData(cropResult);
	}
}

export default FanInfoHeader;
